// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "main") return "main-" + __webpack_require__.h() + ".css";
	// return url for filenames based on template
	return "" + chunkId + ".css";
};